import * as bootstrap from 'bootstrap';

/* FacetsWP Customizations */

export function facetswp_customs() {

	( ( $ ) => {

		if ( $( 'body.page-blog' ).length > 0 ) {
			return;
		}

		if ( 'undefined' == typeof FWP ) {
			return;
		}

		const card_home_active_class = 'highlighted';

		/**
		 * Add classes to form elements
		 */

		// Dropdowns
		if ( $( '.facetwp-dropdown' ).length > 0 ) {
			$( '.facetwp-dropdown' ).addClass( 'form-select' );
		}

		// Search
		if ( $( '.facetwp-search' ).length > 0 ) {
			$( '.facetwp-search' ).addClass( 'form-control' );
		}

		/**
		 * Map loading conditions
		 */

		// Enable the map facet automatically, one time

		$( document ).on( 'facetwp-loaded', ( ev ) => {

			// Disable auto-refresh for the listing page
			FWP.auto_refresh = false;

			// if ( ! $( '.facetwp-map-filtering' ).hasClass( 'enabled' ) ) {
			// 	$( '.facetwp-map-filtering' ).trigger( 'click' );
			// }

			if ( $( '.the-map-column--wrapper' ).length > 0 && 'undefined' !== typeof window.COVE.navbar_total_height ) {
				$( '.the-map-column--wrapper' ).css( 'top', `${window.COVE.navbar_total_height}px` );

				// Set map viewport to fit the whole available height while static
				$( '#facetwp-map' ).css( 'height', `calc(100vh - ${window.COVE.navbar_total_height}px)` )
			}

			$( "#search-this-area" ).on( 'click', ( ev ) => {
				FWP.auto_refresh = true;
				FWP_MAP.is_filtering = true;
				FWP.refresh();
				FWP.auto_refresh = false;
				FWP_MAP.is_filtering = false;

				ev.preventDefault();
			} );

			// Enable card highlight on map marker click
/*
			if ( 'undefined' !== typeof FWP.active_home_id ) {
				let current_card = $( `#card-home-${FWP.active_home_id}` );

				if ( 'undefined' !== typeof current_card.offset() ) {
					let move_to = current_card.offset().top;

					current_card.addClass( card_home_active_class );

					if ( 'undefined' !== typeof window.COVE.navbar_total_height ) {
						move_to = parseInt( move_to - window.COVE.navbar_total_height );
					}
	
					$( 'html, body' ).animate( {
						scrollTop:  `${move_to}px`,
					} );
				}
			}
*/

			// Scroll to top when clicking on pages
			$( '.facetwp-page' ).on( 'click', ( ev ) => {
				$( 'html, body' ).animate( {
					scrollTop: `${$( '.facetwp-template' ).offset().top - window.COVE.navbar_total_height}px`
				} );
			} );

			// Replace the .5 values for fractions in Beds and Baths dropdown
			$( '.dropdown--beds-baths, #accordion-filter-beds-baths' ).find( '.facetwp-display-value' ).each( ( ind, ele ) => {
				let value = $( ele ).text();
				if ( value.indexOf( '.5' ) > -1 ) {
					$( ele ).html( value.replace( '.5', '&frac12;' ) );
				}
			} );

		} );

		// Click on marker
/*
		let loading_map_events = setInterval( () => {
			if ( 'object' !== typeof FWP ) {
				return;
			}

			FWP.hooks.addAction( 'facetwp_map/marker/click', ( marker ) => {
				// const total_pages = FWP.settings.pager.total_pages;
				// const total_rows = FWP.settings.pager.total_rows;
				const element_position = marker.uniqueID;
				const per_page = FWP.settings.pager.per_page;
				const jump_to_page = Math.ceil( element_position / per_page );

				FWP.paged = jump_to_page;
				FWP.soft_refresh = true;
				FWP.active_home_id = marker.post_id;
				FWP.refresh();
			} );

			// Unset the active state on cards when clicking on the map, outside the marker
			google.maps.event.addListener( FWP_MAP.map, 'click', () => {
				$( '.card-home' ).removeClass( card_home_active_class );
				delete( FWP.active_home_id );
			} );

			clearInterval( loading_map_events );
		}, 50 );
*/

		/**
		 * ---------------------------------
		 * HOME LISTINGS SPECIFICS
		 * ---------------------------------
		 */


		// Apply buttons on dropdowns
		$( 'button.facetwp-apply' ).on( 'click', ( ev ) => {
			const parent = $( ev.currentTarget ).parentsUntil( '.dropdown' ).parent();
			const dropdown = new bootstrap.Dropdown( parent.find( '.dropdown-toggle' ) );

			dropdown.hide();

			FWP.refresh();

			ev.preventDefault();
		} );

		// Hide the mobile filter menu
		$( 'div[id$="-mobile-filters"]' ).find( 'button.facetwp-apply' ).on( 'click', ( ev ) => {
			const filters_wrapper = $( 'div[id$="-filters-accordion-wrapper"]' );
			
			const filters_handler = new bootstrap.Collapse( filters_wrapper );

			filters_handler.hide();
		} );

		// Auto refresh for the sorting facets
		if ( $( '.facetwp-type-sort' ).length > 0 ) {
			$( document ).on( 'change', '.facetwp-type-sort select', ( ev ) => {
				FWP.autoload();
				FWP.refresh();
	 		} );
		}

		// Auto refresh for the community list
		if ( $( '.facetwp-type-fselect' ).length > 0 ) {
			$( document ).on( 'change', '.facetwp-type-fselect select', ( ev ) => {
				FWP.refresh();
	 		} );
		}

		if ( $( '.facetwp-type-search' ).length > 0 ) {
			$( document ).on( 'click', '.facetwp-type-search .facetwp-icon', ( ev ) => {
				FWP.refresh();
	 		} );

			$( document ).on( 'keypress', '.facetwp-type-search input', ( ev ) => {
				if ( ev.keyCode == 13 ) {
					FWP.refresh();
				}
	 		} );
		}

		// Remove 'Home Sales: ' and 'Rentals: ' from the user selections

		const replace_home_sales_selections_labels = () => {
			setTimeout( () => {
				$( '#homes-selections, #rentals-selections, #communities-tools .facetwp-selections' ).find( 'ul li' ).each( ( i, e ) => {
					let replaced_value = $( e ).find( '.facetwp-selection-label' ).text()
						.replace( 'Home Sales: ', '' )
						.replace( 'Rentals: ', '' )
						.replace( 'Community: ', '' );
					$( e ).find( '.facetwp-selection-label' ).text( replaced_value );
				} );
			}, 100 );
		};

		FWP.hooks.addAction( 'facetwp/loaded', replace_home_sales_selections_labels );


	} )( window.jQuery );
}